// Function index:
//   HexHistoryOverlay            — handle with open(worldId, hexId, label).
//   mountHexHistoryOverlay()     — wire the static #hex-history-overlay
//       markup (close ×, backdrop click, Escape) once per session; open()
//       labels the header, unhides, and renders via renderHexHistory.

import { renderHexHistory } from '../screens/hex-history.js';

export interface HexHistoryOverlay {
  open(worldId: number, hexId: number, label: string): void;
}

export function mountHexHistoryOverlay(): HexHistoryOverlay {
  const overlay = document.getElementById('hex-history-overlay') as HTMLDivElement;
  const close = document.getElementById('hex-history-close') as HTMLButtonElement;
  const where = document.getElementById('hex-history-where') as HTMLSpanElement;
  const host = document.getElementById('hex-history-host') as HTMLDivElement;

  const hide = (): void => { overlay.hidden = true; };
  close.addEventListener('click', hide);
  overlay.addEventListener('click', (e) => { if (e.target === overlay) hide(); });
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !overlay.hidden) hide();
  });

  return {
    open(worldId, hexId, label) {
      where.textContent = label;
      overlay.hidden = false;
      // renderHexHistory owns its loading / error states.
      void renderHexHistory(host, worldId, hexId);
    },
  };
}
